/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const FileKeynote16 = (props: SVGProps) => (
    <AccessibleSVG width={16} height={16} viewBox="0 0 16 16" {...props}>
        <path
            fill={vars.bdlGray50}
            fillRule="evenodd"
            d="M13.904 8.137a.39.39 0 01-.086.112l-.114.085H3.205a.43.43 0 01-.114-.085.424.424 0 01-.086-.112.411.411 0 010-.131v-.562H14v.562a.439.439 0 01-.096.13zM3.205 6.976s.134-2.351.173-3.147v-.375a1.168 1.168 0 010-.187.617.617 0 01.057-.178.6.6 0 01.449-.309h.736v-.525a1.97 1.97 0 010-.243.78.78 0 01.24-.46.698.698 0 01.19-.121.912.912 0 01.278-.084h1.415a.15.15 0 00.124 0l.153-.207a.47.47 0 01.115-.093L7.288 1h1.32l.152.047a.475.475 0 01.23.225.534.534 0 01.057.15c.006.05.006.1 0 .15a.86.86 0 010 .215.516.516 0 01-.057.15.535.535 0 01-.23.224l-.153.057H7.288a.678.678 0 01-.153-.047l-.096-.066-.153-.159a.166.166 0 00-.114-.066H5.29a.328.328 0 00-.134.132.29.29 0 000 .093.954.954 0 000 .169v.534h7.907a.65.65 0 01.335.159.557.557 0 01.172.328c.005.062.005.125 0 .187v.3c0 .608.172 3.212.172 3.212H3.205v-.018zm2.869 6.087h1.912V8.85h.956v4.214h1.912c.264 0 .478.21.478.469a.473.473 0 01-.478.468h-4.78a.473.473 0 01-.478-.468c0-.259.214-.469.478-.469z"
        />
    </AccessibleSVG>
);

export default FileKeynote16;
